import React, { FC, memo } from "react";

import { SocAuthCallbackScreen } from "../";

export const AccountYandexRedirect: FC = memo(() => <SocAuthCallbackScreen network="yandex" />);
